import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { BehaviorSubject, filter, fromEvent, map, Subject, switchMap, takeUntil, throttleTime } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[uiDropdownWidth]',
})
export class BoschUiDropdownWidthDirective implements OnInit, OnDestroy {
  private readonly elementRef = inject(ElementRef);
  private readonly document: Document = inject(DOCUMENT);
  @Input('uiDropdownWidth') set isDropdownOpened(isOpen: boolean) {
    this._isOpen$.next(isOpen);
  }
  @Input() customDropdownListWidth = 0;
  @Output() widthChange: EventEmitter<number> = new EventEmitter<number>();

  private _isOpen$ = new BehaviorSubject(false);
  private _contentWidth$ = new BehaviorSubject(0);
  private _unsubscribe$ = new Subject<void>();

  constructor() {
    this._isOpen$.next(false);
  }

  ngOnInit(): void {
    this._isOpen$
      .pipe(
        filter(Boolean),
        map(() =>
          this.customDropdownListWidth ? this.customDropdownListWidth : this.elementRef.nativeElement.offsetWidth,
        ),
        takeUntil(this._unsubscribe$),
      )
      .subscribe((contentWidth: number) => this._contentWidth$.next(contentWidth));
    this._isOpen$
      .pipe(
        filter(Boolean),
        map(() => this.document.defaultView),
        filter((windowRef: Window | null): windowRef is Window => windowRef !== null),
        switchMap((windowRef: Window) =>
          fromEvent(windowRef, 'resize').pipe(
            takeUntil(this._isOpen$.pipe(filter((isOpen: boolean) => !isOpen))),
            throttleTime(200),
          ),
        ),
        takeUntil(this._unsubscribe$),
      )
      .subscribe(() =>
        this._contentWidth$.next(
          this.customDropdownListWidth ? this.customDropdownListWidth : this.elementRef.nativeElement.offsetWidth,
        ),
      );
    this._contentWidth$.pipe(takeUntil(this._unsubscribe$)).subscribe((width: number) => this.widthChange.next(width));
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
  }
}
